
import React, { Component } from 'react';
import {DateWidget} from 'form/new/DateWidget';
import {ListContext} from '../../core/ListProvider';
import { FormControl, Button, ButtonGroup, FormGroup } from '@material-ui/core';
import {InputWidget} from 'form/InputWidget';
import styled from 'styled-components';
import { AsyncAutocompleteWidget2 } from 'form/AutocompleteWidget2';
import { AsyncAutocompleteWidget } from 'form/AutocompleteWidget';
import { AutocompleteMultipleWidget2 } from "form/AutocompleteMultipleWidget2";
import {Grid} from "../../ui/Grid";

const StyledFormControl = styled(FormControl)`
  margin-bottom: 20px;
`;


export default class OrderListTableFilter extends Component {
  render() {
    const { client } = this.props;
    return (
      <ListContext.Consumer>
        {context => {
          const { filter, setFilterValue } = context;

          return (
            <FormGroup>

              <div className={'mb-20'}>
                <ButtonGroup>
                  <Button
                    onClick={() => context.setFilter({})}
                    variant={'outlined'}
                    disabled={context.hasFilter()}
                  >
                    Сбросить
                  </Button>
                </ButtonGroup>
              </div>

              <StyledFormControl fullWidth={true} variant="outlined">
                <InputWidget
                  size={'small'}
                  name={'id'}
                  value={filter.id}
                  onChange={(value) => setFilterValue('id', value)}
                  label={'Номер перевозки'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'catalog/order_status'}
                  optionLabel={'label'}
                  value={filter.order_status}
                  onChange={(option) => setFilterValue('order_status', option)}
                  size={'small'}
                  label={'Статус перевозки'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'catalog/choice'}
                  optionLabel={'name'}
                  filter={{
                    type: 'ORDER_TYPE'
                  }}
                  value={filter.order_type}
                  onChange={(option) => setFilterValue('order_type', option)}
                  size={'small'}
                  label={'Тип перевозки'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'catalog/order_payment_status'}
                  optionLabel={'label'}
                  value={filter.order_payment_status}
                  onChange={(option) => setFilterValue('order_payment_status', option)}
                  size={'small'}
                  label={'Статус оплаты'}
                />
              </StyledFormControl>

              <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
                <StyledFormControl fullWidth={true} variant="outlined">
                  <DateWidget
                    value={filter.date_range_start}
                    onChange={(value, stringValue) => setFilterValue('date_range_start', stringValue)}
                    label={'Дата начала'}
                    size={'small'}
                  />
                </StyledFormControl>

                <StyledFormControl fullWidth={true} variant="outlined">
                  <DateWidget
                    value={filter.date_range_end}
                    onChange={(value, stringValue) => setFilterValue('date_range_end', stringValue)}
                    label={'Дата завершения'}
                    size={'small'}
                    disabled={!filter.date_range_start}
                    minRangeDate={filter.date_range_start}
                  />
                </StyledFormControl>
              </Grid>

              <StyledFormControl fullWidth={true} variant="outlined">
                <DateWidget
                  value={filter.date_of_application}
                  onChange={(value, stringValue) => setFilterValue('date_of_application', stringValue)}
                  label={'Дата подачи'}
                  size={'small'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <InputWidget
                  size={'small'}
                  name={'container_number__icontains'}
                  value={filter.container_number__icontains}
                  onChange={(value) => setFilterValue('container_number__icontains', value)}
                  label={'Номер контейнера'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'catalog/choice'}
                  optionLabel={'label'}
                  filter={{
                    type: 'CONTAINER_OWNER'
                  }}
                  value={filter.container_owner}
                  onChange={(option) => setFilterValue('container_owner', option)}
                  size={'small'}
                  label={'Собственник'}
                />
              </StyledFormControl>

              {client ? (
                <StyledFormControl fullWidth={true} variant="outlined">
                  <AutocompleteMultipleWidget2
                    url={'client/counterparty'}
                    filter={{
                      client: client.id
                    }}
                    optionLabel={'name'}
                    value={filter.counterparty}
                    onChange={(option, optionsId) => setFilterValue('counterparty', optionsId)}
                    size={'small'}
                    label={'Контрагент'}
                  />
                </StyledFormControl>
              ) : (
                <Grid columns={'1fr 1fr'} mobileColumns={'1fr'}>
                  <StyledFormControl fullWidth={true} variant="outlined">
                    <AsyncAutocompleteWidget2
                      url={'client'}
                      optionLabel={'name'}
                      value={filter.client}
                      onChange={(option) => setFilterValue('client', option)}
                      size={'small'}
                      label={'Клиент'}
                    />
                  </StyledFormControl>

                  <StyledFormControl fullWidth={true} variant="outlined">
                    <AutocompleteMultipleWidget2
                      url={'client/counterparty'}
                      filter={{
                        client: filter.client
                      }}
                      optionLabel={'name'}
                      value={filter.counterparty}
                      onChange={(option, optionsId) => setFilterValue('counterparty', optionsId)}
                      size={'small'}
                      label={'Контрагент'}
                    />
                  </StyledFormControl>
                </Grid>
              )}

              <StyledFormControl fullWidth={true} variant="outlined">
                <AutocompleteMultipleWidget2
                  url={'client/contact_person'}
                  filter={{
                    counterparty__client: client ? client.id : filter.client,
                    counterparty: filter.counterparty
                  }}
                  optionLabel={'name'}
                  value={filter.contact_persons}
                  onChange={(option, optionsId) => setFilterValue('contact_persons', optionsId)}
                  size={'small'}
                  label={'Контактные лица'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget
                  url={'catalog/choice'}
                  filter={{
                    type: 'CARRIER'
                  }}
                  value={filter.carrier}
                  onChange={(option) => setFilterValue('carrier', option ? option.id : undefined)}
                  size={'small'}
                  label={'Перевозчик'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'fleet/driver'}
                  optionLabel={'full_name'}
                  value={filter.driver}
                  onChange={(option) => setFilterValue('driver', option)}
                  size={'small'}
                  label={'Водитель'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'fleet/truck'}
                  optionLabel={'label'}
                  value={filter.tractor_unit}
                  onChange={(option) => setFilterValue('tractor_unit', option)}
                  size={'small'}
                  label={'Транспортное средтсво'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AsyncAutocompleteWidget2
                  url={'fleet/trailer'}
                  optionLabel={'label'}
                  value={filter.semi_trailer}
                  onChange={(option) => setFilterValue('semi_trailer', option)}
                  size={'small'}
                  label={'Полуприцеп'}
                />
              </StyledFormControl>

              <StyledFormControl fullWidth={true} variant="outlined">
                <AutocompleteMultipleWidget2
                  url={'catalog/point'}
                  value={filter.points}
                  optionLabel={'label'}
                  onChange={(option, optionsId) => setFilterValue('points', optionsId)}
                  size={'small'}
                  label={'Точки'}
                />
              </StyledFormControl>

            </FormGroup>
          )
        }}
      </ListContext.Consumer>
    )
  }
}